import { Injectable } from '@angular/core';
import { PlanningHasEntity } from '../../classes/planning-has-entity.class';
import { Utils } from '../../utils.class';
import { Features } from '../auth/features';
import { RealtimeService } from '../realtime/realtime.service';
import { WebsocketService } from '../websocket/websocket.service';

@Injectable({
    providedIn: 'root',
})
export class PlanningHasService extends RealtimeService<PlanningHasEntity> {
    constructor(protected websocketService: WebsocketService) {
        super(websocketService, Features.PlanningPlanningHas);
    }

    disconnect(): void {
        this.requestedDates.clear();
        this.websocket.disconnect();
    }

    itemInDaterange(planning: PlanningHasEntity, fromDate: Date, toDate: Date) {
        return (
            Utils.getTimeOrNull(planning.begindate) < Utils.getTimeOrNull(toDate) &&
            Utils.getTimeOrNull(planning.enddate) > Utils.getTimeOrNull(fromDate)
        );
    }
}
